export const baseStyles = ({ placement, zIndex, floaterStyles }) => {
  let altStyles = {};
  const {
    floater = {},
    container = {},
    arrow = {},
    options = {},
  } = floaterStyles;
  if (placement === 'left') {
    altStyles = {
      left: -25,
    };
  } else if (placement === 'right') {
    altStyles = {
      right: 9,
    };
  } else if (placement === 'top') {
    altStyles = {
      top: 9,
    };
  } else if (placement === 'bottom') {
    altStyles = {
      bottom: 9,
    };
  }
  return {
    floater: {
      padding: 20,
      zIndex,
      width: 0,
      ...floater,
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      backgroundColor: '#00BED5',
      color: '#ffffff',
      fontWeight: 'bold',
      minWidth: '34px',
      minHeight: '34px',
      borderRadius: '50%',
      padding: '0px 10px',
      ...altStyles,
      ...container,
    },
    arrow: {
      color: '#00BED5',
      length: 30,
      spread: 30,
      margin: 0,
      ...arrow,
    },
    ...options,
  };
};

export const oneIconStyles = {
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  width: '30px',
  height: '30px',
  backgroundColor: '#00BED5',
  borderRadius: '50%',
  color: '#ffffff',
  fontWeight: 'bold',
  padding: '0px 10px 0px 10px',
  marginRight: '12px',
};
